module.exports = __webpack_public_path__ + "static/media/spotify.a3c4ba6e.svg";